import React from 'react';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
export const Loading: React.FC<React.PropsWithChildren<unknown>> = () => {
  return (
    <Box sx={{ position: 'fixed', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}>
      <CircularProgress data-testid="loading" />
    </Box>
  );
};
